import { createFileRoute, redirect } from "@tanstack/react-router"
import { roleFromPath, roleJoinPath } from "@/lib/auth-client"

// /signup (the shared, role-dropdown signup form) is replaced by two
// locked-role doors: /jobs/join and /recruit/join. A bare old link carries no
// role signal, so it lands on the common home page to pick — but a link with
// a returnTo can usually be inferred (e.g. ?returnTo=/recruit/jobs/new), so
// send those straight to the matching door instead of losing the destination.
export const Route = createFileRoute("/signup")({
  validateSearch: (search: Record<string, unknown>): { returnTo?: string } => ({
    returnTo: typeof search.returnTo === "string" ? search.returnTo : undefined,
  }),
  beforeLoad: ({ search }) => {
    const role = roleFromPath(search.returnTo)
    if (role) {
      throw redirect({
        to: roleJoinPath(role),
        search: { returnTo: search.returnTo },
      })
    }
    throw redirect({ to: "/" })
  },
  component: () => null,
})
